export const Logo = ({ size = "text-base sm:text-xl", compact }) => (
  <div className="flex items-center gap-2 select-none">
    <div className="relative w-8 h-8 sm:w-9 sm:h-9 shrink-0 rounded-full flex items-center justify-center font-display font-black text-[#3a2a00] text-sm"
      style={{ background: "radial-gradient(circle at 30% 30%, #fff3b0, #FFD700 35%, #D4AF37 65%, #7a5c0e)" }}>
      J
    </div>
    <span className={`font-display font-black tracking-tight whitespace-nowrap ${size} ${compact ? "hidden sm:inline" : ""}`}>
      <span className="gold-text">JACKPOT</span> <span className="text-[#c4112f]">AZ</span>
    </span>
  </div>
);
